import get from 'lodash/get'
import styled from 'styled-components'

import { Appear } from 'bl-common/src/units/Appear'

import { withTransition } from '../../../utils/withTransition'
import { ErrorPage } from '../../ErrorPage'
import Page from '../../Page'
import NewsletterSignupFormSection from '../../TemplatePage/sections/NewsletterSignupFormSection'
import { ExploreTopics } from './ExploreTopics'
import { FeaturedStory } from './FeaturedStory'
import HeaderSection from './HeaderSection'
import { LatestStories } from './LatestStories'
import { LatestStoryStandalone } from './LatestStoryStandalone'
import { RelatedExperiences } from './RelatedExperiences'
import { StoryArchive } from './StoryArchive'

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const MAX_LATEST_STORIES = 5

const StoryTopicPage = ({ page, stories, notFound }) => {
  if (notFound) {
    return <ErrorPage />
  }

  const { newsletterSignup } = page
  const { topicName, topicDescription, relatedExperience } = get(
    stories[0],
    'fields.topic.fields',
    {}
  )

  const otherTopics = page.exploreOtherTopics.filter(
    topic => topic.fields.topicName !== topicName
  )

  const featuredStory = stories.find(
    story => get(story, 'fields.featured', false) === true
  )

  const latestStories = stories.slice(0, MAX_LATEST_STORIES)
  const otherStories = stories.slice(MAX_LATEST_STORIES)

  return (
    <Page breadcrumb={`Topic: ${topicName} `}>
      <HeaderSection
        heading={topicName}
        subtitle={topicDescription}
        showBreadcrumb
      />
      {latestStories.length === 1 && (
        <LatestStoryStandalone
          story={latestStories[0]}
          bottom={{ xs: 2, md: 8 }}
        />
      )}
      {latestStories.length > 1 && (
        <LatestStories stories={latestStories} bottom={{ xs: 2, md: 6 }} />
      )}
      {featuredStory && (
        <FlexContainer>
          <FeaturedStory
            verticalOffsetDirection="bottom"
            story={featuredStory}
            top={{ xs: 2, md: 14 }}
            bottom={{
              md: 6,
            }}
          />
        </FlexContainer>
      )}
      {relatedExperience && (
        <RelatedExperiences relatedExperience={relatedExperience} />
      )}
      {!!otherStories.length && (
        <Appear observer>
          <StoryArchive
            stories={otherStories}
            top={{
              xs: relatedExperience ? 3 : 2,
              md: relatedExperience ? 8 : 4,
            }}
            bottom={{ xs: 2, md: 8 }}
            breakOnMobile
          />
        </Appear>
      )}
      <ExploreTopics
        topics={otherTopics}
        heading="Explore other topics"
        description="Discover the waters of the Blue Lagoon. Journey through a spa of the volcanic earth. Harmonize with nature."
      />
      {newsletterSignup && (
        <NewsletterSignupFormSection section={newsletterSignup} />
      )}
    </Page>
  )
}

export default withTransition(StoryTopicPage)
